document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const blocks = document.querySelectorAll('.footer-block');

  blocks.forEach(block => {
    const heading = block.querySelector('.footer-block__heading, h2, h3, h4');
    if (!heading) return;

    if (isMobile && !heading.querySelector('.toggle-symbol')) {
      const sym = document.createElement('span');
      sym.className = 'toggle-symbol';
      sym.textContent = '+';
      heading.appendChild(sym);
    }

    heading.addEventListener('click', () => {
      const open = block.classList.toggle('is-open');
      const symbol = heading.querySelector('.toggle-symbol');
      if (symbol) symbol.textContent = open ? '–' : '+';
    });
  });
});


